export default __webpack_public_path__ + "3adea7d.png";